import { Link } from 'react-router-dom';
import {
  Townhouse,
  SolarPanels,
  Pool,
  NewConstruction,
  PetFriendly,
  Fireplace,
  SmartHome,
  Parking,
  ScenicViews,
  Lake,
  Office,
  Wifi,
} from '../../assets/icons';

import { TOOLTIP_TEXT } from './../../utils/constant';

const tooltipData =
  'Lorem ipsum dolor sit amet consectetur adipiscing elit. Congue euismod elementum interdum viverra luctus faucibus egestas morbi.';

export const headerData = {
  market: 'Initial Offering',
  propertyName: 'The Wellington',
  isFavorite: true,
};

export const labelData = {
  label: 'Fully Funded',
  type: 'green',
};

export const cardData = {
  openOrders: '3',
  tradeLabel: 'Trade',
  buyLabel: 'Buy',
  sellLabel: 'Sell',
  cardInfoData: [
    {
      label: 'Last price',
      value: 'lastPrice',
      prefix: '$',
    },
    {
      label: 'All time',
      value: 'allTime',
      suffix: '%',
    },
    {
      label: 'Div yield',
      tooltip: TOOLTIP_TEXT.FIRST_DIVIDEND_YIELD,
      value: 'dividendYield',
      suffix: '%',
    },
  ],
  activityData: {
    bids: '9',
    asks: '4',
  },
};

export const tradeData = {
  openOrders: '3',
  tradeLabel: 'Trade',
  buyLabel: 'Buy',
  sellLabel: 'Sell',
  cardInfoData: [
    {
      label: 'Last price',
      value: '$10.25',
    },
    {
      label: 'All time',
      value: '+0.25%',
    },
    {
      label: 'Div yield',
      tooltip:
        'The dividend percentage is the most recent profit-sharing amount paid by Realbricks to this property’s investors. It is paid, and varies, on a quarterly basis. The dividend percentage is calculated by dividing the total dividend payment (to be split amongst share owners) by the total property purchase price (raised during the initial offering period). The dividend payment you receive will be proportional to your ownership of the property.',
      value: '3.6%',
    },
  ],
  activityData: {
    highestBid: '$10.50',
    lowestAsk: '$10.66',
    bids: '9',
    asks: '4',
  },
  graphData: {
    status: 'decline',
    pricePerShare: '-0.59',
    dataDuration: 'prev 30d',
  },
};

export const basicData = {
  basics: [
    {
      label: 'bedrooms',
      value: '5',
    },
    {
      label: 'baths',
      value: '3',
    },
    {
      label: 'Sq.Ft',
      value: '2,150',
    },
    {
      label: 'built',
      value: '1985',
    },
  ],
  advance: [
    {
      label: 'Property type',
      value: 'Vacation rental',
    },
    {
      label: 'Location',
      value: 'Portland, OR',
    },
    {
      label: 'Purchase price',
      tooltip: tooltipData,
      value: '$1,234,567',
    },
    {
      label: 'Avg cost to rent',
      value: '$200/night',
    },
  ],
};

export const aboutData = {
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Egestas dui, aliquet curabitur turpis amet, arcu blandit lectus. Eu eu, in mauris sed in fermentum ac. Lorem est ut sed leo adipiscing quam leo at. Eu nibh neque ipsum, nec praesent sapien, odio. Vivamus ut orci tempor morbi enim tempus tempus vulputate. Ut ut diam nibh odio at luctus eget odio. Eget ut a ut diam elementum pharetra amet. Eget facilisis egestas nunc arcu lacus amet. Nunc lobortis suspendisse magna commodo amet, in dolor. Eget nibh sem cursus imperdiet ac nam in. Egestas pulvinar eu habitant morbi leo, etiam sed.',
  amenities: [
    {
      icon: <Townhouse />,
      label: 'Townhouse',
    },
    {
      icon: <SolarPanels />,
      label: 'Solar panels',
    },
    {
      icon: <Pool />,
      label: 'Pool',
    },
    {
      icon: <NewConstruction />,
      label: 'New construction',
    },
    {
      icon: <PetFriendly />,
      label: 'Pet friendly',
    },
    {
      icon: <Fireplace />,
      label: 'Fireplace',
    },
    {
      icon: <SmartHome />,
      label: 'Smart home',
    },
    {
      icon: <Parking />,
      label: '2 Car garage',
    },
    {
      icon: <ScenicViews />,
      label: 'Scenic views',
    },
    {
      icon: <Lake />,
      label: 'Lake',
    },
    {
      icon: <Office />,
      label: 'Office',
    },
    {
      icon: <Wifi />,
      label: 'Wifi',
    },
  ],
};

export const manageData = {
  manageTitle: 'Property Management Partner',
  manageData: [
    {
      label: 'Property status',
      tooltip: tooltipData,
      value: 'Rent ready',
    },
    {
      label: 'Anticipated dividend date',
      tooltip: tooltipData,
      value: 'Jan 2023',
    },
    {
      label: 'Occupancy rate',
      tooltip: tooltipData,
      value: '80%',
    },
    {
      label: 'Estimated dividend yield',
      tooltip: tooltipData,
      value: '3.6% per year',
    },
  ],
  processTitle: 'Pacaso Second Homes',
  processDescription: (
    <p>
      Pacaso is a property broker that buys single-family homes and sells them to consortiums of buyers. The San Francisco–based company claims it
      reached unicorn status faster than any other USA-based company.{' '}
      <Link className='fw-600 underline text-terracotta' to='/not-found/'>
        Learn more
      </Link>{' '}
    </p>
  ),
};

export const marketData = {
  location: 'Downtown Portland',
  description: (
    <>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Congue euismod elementum interdum viverra luctus faucibus egestas morbi. Ipsum velit,
        nibh posuere dignissim. Congue euismod elementum interdum viverra luctus faucibus egestas morbi.Urna, arcu amet pellentesque semper.
      </p>

      <p>
        Congue euismod elementum interdum viverra luctus faucibus egestas morbi.Urna, arcu amet pellentesque semper. Lorem ipsum dolor sit amet,
        consectetur adipiscing elit. Congue euismod elementum interdum viverra luctus faucibus egestas morbi. Ipsum velit, nibh posuere dignissim.{' '}
      </p>
    </>
  ),
  address: '234 SW Main St, Portland OR, 01119',
  addressLink: 'https://goo.gl/maps/2aHWQPQ7HiuE1Vrs6',
  mapLink:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2795.741383858691!2d-122.6787021841301!3d45.51528443805376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54950a0fc618ffd3%3A0xfb55e7e2263a231f!2s234%20SW%20Main%20St%2C%20Portland%2C%20OR%2097204%2C%20USA!5e0!3m2!1sen!2sin!4v1672640584558!5m2!1sen!2sin',
  grade: 'B',
  score: 68,
  parameters: [
    {
      label: 'Rental demand',
      tooltip: tooltipData,
      value: 84,
    },
    {
      label: 'Revenue growth',
      tooltip: tooltipData,
      value: 43,
    },
    {
      label: 'Seasonality',
      tooltip: tooltipData,
      value: 72,
    },
    {
      label: 'Regulation',
      tooltip: tooltipData,
      value: 33,
    },
    {
      label: 'Investibility',
      tooltip: tooltipData,
      value: 33,
    },
  ],
};

export const offeringData = {
  details: [
    {
      label: 'Mortgage amount',
      tooltip: tooltipData,
      value: '$400,000',
    },
    {
      label: 'Mortgage interest rate',
      tooltip: tooltipData,
      value: '5.95%',
    },
    {
      label: 'Equity raised',
      value: '$1,120,000',
    },
    {
      label: 'Initial Offering Price',
      value: '$10',
    },
    {
      label: 'Total Shares',
      value: '112,000',
    },
    {
      label: 'Leverage',
      tooltip: tooltipData,
      value: '6%',
    },
  ],
  rating: 'medium',
  expanses: [
    {
      label: 'Purchase price',
      tooltip: tooltipData,
      amount: '$1,234,567',
    },
    {
      label: '$1,234,567',
      tooltip: tooltipData,
      amount: '$199,900',
    },
    {
      label: 'Closing, offering & holding costs',
      tooltip: tooltipData,
      amount: '$163,450',
    },
    {
      label: 'Realbricks sourcing fee',
      tooltip: tooltipData,
      amount: '$40,000',
    },
  ],
  fees: [
    {
      name: 'Realbricks AUM fee (quarterly)',
      amount: '$675',
      tooltip: tooltipData,
      points: ['Purchase price: 0.125% of the property purchase price (quarterly)', 'Gross rents fee: 5% of gross revenue'],
    },
    {
      name: 'Property management fees (monthly)',
      tooltip: tooltipData,
      points: [
        'Gross rents fee: 15% (up to 20% depending on the performance of the property)',
        'Furniture, fixtures, and equipment: Included in the use of proceeds listed above when our property management partners assist in the furnishing and property update process',
      ],
    },
  ],
  documents: [
    {
      name: 'Use of proceeds',
      link: '/not-found/',
    },
    {
      name: 'Risk factors',
      link: '/not-found/',
    },
    {
      name: 'Series overview',
      link: '/not-found/',
    },
    {
      name: 'Offering circular',
      link: '/not-found/',
    },
  ],
};

const answer =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget aliquet sit dictumst nulla interdum. Viverra elit mattis donec sed. Integer viverra metus cras nibh etiam. Amet fusce arcu tellus sit.';

export const faqData = {
  faqData: [
    {
      question: 'Lorem ipsum dolor sit amet?',
      answer: answer,
    },
    {
      question: 'Consectetur adipiscing elit?',
      answer: answer,
    },
    {
      question: 'Eget aliquet sit dictumst nulla interdum?',
      answer: answer,
    },
    {
      question: 'Viverra elit mattis donec sed?',
      answer: answer,
    },
    {
      question: 'Integer viverra metus cras nibh etiam?',
      answer: answer,
    },
  ],
};
